import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import { get } from 'lodash';
import { withCookies, Cookies } from 'react-cookie';
import MainContent from './MainContent';
import DefaultLayout from '../../layouts/Default';
import ErrorMessage from '../../components/ErrorMessage';
import * as utils from '../../store/utils';
import * as actions from '../../store/actions';

class Home extends PureComponent {

  renderDefaultLayout() {
    return (
      <DefaultLayout {...this.props} pageType="Home">
        { this.props.errors ?
          <ErrorMessage {...this.props} />
          :
          <MainContent {...this.props} />
        }
      </DefaultLayout>
    );
  }

  render() {
    return (this.renderDefaultLayout());
  }
}

Home.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  errors: PropTypes.bool,
  search: PropTypes.shape({
    count: PropTypes.number,
  }).isRequired,
  seoContent: PropTypes.array,
  success: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    search: get(state.app, 'data.search', {}),
    seoContent: get(state.app, 'data.seoContent', []),
    premiumFeaturedAd: get(state.app, 'data.premiumFeaturedAd', undefined),
    blogSection: get(state.app, 'data.blogSection', undefined),
    isWorking: state.app.isWorking,
    componentWorking: state.app.componentWorking,
    success: state.app.success,
    errors: state.app.errors,
    message: state.app.message,
    statusCode: state.app.statusCode
  };
};

export default withCookies(connect(
  mapStateToProps,
  null
)(frontloadConnect(({ dispatch, location }) => {

  if (utils.isServer()) {
    return dispatch(actions.getHomeData());
  }

  if (actions.shouldGetData(location)) {
    return dispatch(actions.getHomeData());
  }
}, {
  onUpdate: true,
  onMount: true
})(Home)));
